import React from 'react';
import { Card, Form, Input, Select, Row, Col } from 'antd';
import { FormInstance } from 'antd/es/form';

const { Option } = Select;

interface PositionInformationProps {
  form: FormInstance;
}

const PositionInformation: React.FC<PositionInformationProps> = ({ form }) => {
  const yesNoOptions = ['Yes', 'No'];

  return (
    <Card title="Position Information" style={{ marginBottom: 16 }}>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Title of job you weren't selected for"
            name={['position_info', 'job_title']}
          >
            <Input placeholder="Enter job title" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="What was the date you weren't selected?"
            name={['position_info', 'date_not_selected']}
          >
            <Input placeholder="Enter date" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Did you apply for the job?"
            name={['position_info', 'did_apply']}
          >
            <Select placeholder="Select">
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Did you qualify for the job?"
            name={['position_info', 'did_qualify']}
          >
            <Select placeholder="Select">
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};

export default PositionInformation;

